(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["content-tabs"] && !Shopify.designMode) return;
  try {
    
  function initTabs(container) {
      const tabs = container.querySelectorAll('[role="tab"]');
      const panel = container.querySelector('[role="tabpanel"]');
      const contentScript = container.querySelector('[data-tabs-content]');
      
      if (!tabs.length || !panel || !contentScript) return;
      
      let contentData;
      try {
        contentData = JSON.parse(contentScript.textContent);
      } catch(e) {
        console.error('Erro ao parsear dados das tabs:', e);
        return;
      }
      
      const textColumn = panel.querySelector('.content-tabs-text');
      const mediaColumn = panel.querySelector('.content-tabs-media');
      
      if (!textColumn || !mediaColumn) return;
      
      function updateContent(blockId) {
        const blockData = contentData.find(b => b.id === blockId);
        if (!blockData) {
          console.warn('Block data não encontrado para ID:', blockId);
          return;
        }
        
        // Elementos de texto
        const titleEl = textColumn.querySelector('[data-content="title"]');
        const subtitleEl = textColumn.querySelector('[data-content="subtitle"]');
        const descEl = textColumn.querySelector('[data-content="description"]');
        const existingWrapper = mediaColumn.querySelector('.content-tabs-media-wrapper');
        
        // Fase 1: Fade out dos elementos atuais
        if (titleEl) titleEl.classList.add('fade-out');
        if (subtitleEl) subtitleEl.classList.add('fade-out');
        if (descEl) descEl.classList.add('fade-out');
        if (existingWrapper) existingWrapper.classList.add('fade-out');
        
        // Fase 2: Após fade out, atualiza conteúdo e faz fade in
        setTimeout(function() {
          // Atualiza título
          if (titleEl) {
            titleEl.textContent = blockData.title || '';
            titleEl.style.display = blockData.title ? '' : 'none';
            titleEl.classList.remove('fade-out');
            titleEl.classList.add('fade-in');
            setTimeout(function() {
              titleEl.classList.remove('fade-in');
            }, 400);
          }
          
          // Atualiza subtítulo
          if (subtitleEl) {
            subtitleEl.textContent = blockData.subtitle || '';
            subtitleEl.style.display = blockData.subtitle ? '' : 'none';
            subtitleEl.classList.remove('fade-out');
            subtitleEl.classList.add('fade-in');
            setTimeout(function() {
              subtitleEl.classList.remove('fade-in');
            }, 400);
          }
          
          // Atualiza descrição
          if (descEl) {
            descEl.innerHTML = blockData.description || '';
            descEl.style.display = blockData.description ? '' : 'none';
            descEl.classList.remove('fade-out');
            descEl.classList.add('fade-in');
            setTimeout(function() {
              descEl.classList.remove('fade-in');
            }, 400);
          }
          
          // Atualiza mídia
          const existingClasses = existingWrapper ? Array.from(existingWrapper.classList) : [];
          const existingBorderRadius = existingWrapper ? existingWrapper.style.borderRadius : '';
          
          if (existingWrapper) {
            existingWrapper.remove();
          }
          
          if (blockData.media_type === 'image' && blockData.media_image) {
            const imgWrapper = document.createElement('div');
            imgWrapper.className = 'content-tabs-media-wrapper fade-in';
            existingClasses.forEach(cls => {
              if (cls.startsWith('content-tabs-media--desktop-') || cls.startsWith('content-tabs-media--mobile-')) {
                imgWrapper.classList.add(cls);
              }
            });
            if (existingBorderRadius) {
              imgWrapper.style.borderRadius = existingBorderRadius;
            }
            
            const img = document.createElement('img');
            img.src = blockData.media_image;
            img.alt = blockData.media_alt || blockData.title || '';
            img.className = 'content-tabs-image';
            img.loading = 'lazy';
            
            imgWrapper.appendChild(img);
            mediaColumn.appendChild(imgWrapper);
            
            setTimeout(function() {
              imgWrapper.classList.remove('fade-in');
            }, 400);
          } else if (blockData.media_type === 'video' && blockData.media_video && blockData.media_video.mp4) {
            const videoWrapper = document.createElement('div');
            videoWrapper.className = 'content-tabs-media-wrapper fade-in';
            existingClasses.forEach(cls => {
              if (cls.startsWith('content-tabs-media--desktop-') || cls.startsWith('content-tabs-media--mobile-')) {
                videoWrapper.classList.add(cls);
              }
            });
            if (existingBorderRadius) {
              videoWrapper.style.borderRadius = existingBorderRadius;
            }
            
            const video = document.createElement('video');
            video.className = 'content-tabs-video';
            video.playsInline = true;
            if (blockData.media_video.preview) {
              video.poster = blockData.media_video.preview;
            }
            
            const source = document.createElement('source');
            source.src = blockData.media_video.mp4;
            source.type = blockData.media_video.mime_type || 'video/mp4';
            video.appendChild(source);
            
            videoWrapper.appendChild(video);
            mediaColumn.appendChild(videoWrapper);
            
            setTimeout(function() {
              videoWrapper.classList.remove('fade-in');
            }, 400);
          } else {
            // Imagem de exemplo quando a aba não tem mídia inserida
            const placeholderTemplate = container.querySelector('.content-tabs-media-placeholder-template');
            if (placeholderTemplate && placeholderTemplate.content) {
              const placeholderClone = placeholderTemplate.content.cloneNode(true);
              const wrapper = placeholderClone.querySelector('.content-tabs-media-wrapper');
              if (wrapper) {
                wrapper.classList.add('fade-in');
                if (existingBorderRadius) {
                  wrapper.style.borderRadius = existingBorderRadius;
                }
                mediaColumn.appendChild(placeholderClone);
                setTimeout(function() {
                  wrapper.classList.remove('fade-in');
                }, 400);
              }
            }
          }
        }, 300); // Aguarda fade out completar
      }
      
      tabs.forEach(function(tab) {
        tab.onclick = function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const clickedTab = this;
          const blockId = clickedTab.getAttribute('data-tab');
          
          // Atualiza tabs
          tabs.forEach(function(t) {
            if (t === clickedTab) {
              t.classList.add('active');
              t.setAttribute('aria-selected', 'true');
            } else {
              t.classList.remove('active');
              t.setAttribute('aria-selected', 'false');
            }
          });
          
          // Atualiza conteúdo
          updateContent(blockId);
        };
      });
      
      // Setas do carrossel
      const arrows = container.querySelectorAll('.content-tabs-carousel-arrow');
      arrows.forEach(function(arrow) {
        arrow.onclick = function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const isPrev = this.classList.contains('content-tabs-carousel-arrow--prev');
          const activeTab = container.querySelector('[role="tab"].active');
          if (!activeTab) return;
          
          const allTabs = Array.from(tabs);
          const currentIndex = allTabs.indexOf(activeTab);
          let targetTab;
          
          if (isPrev) {
            targetTab = currentIndex > 0 ? allTabs[currentIndex - 1] : allTabs[allTabs.length - 1];
          } else {
            targetTab = currentIndex < allTabs.length - 1 ? allTabs[currentIndex + 1] : allTabs[0];
          }
          
          if (targetTab) {
            targetTab.onclick(e);
          }
        };
      });
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    // Inicializar todas as seções
    document.querySelectorAll('[data-section-id]').forEach(initTabs);
  });
  
  // Reinitialize on section reload (Shopify theme editor)
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      const container = event.target.querySelector('[data-section-id]');
      if (container) {
        initTabs(container);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["features-carousel"] && !Shopify.designMode) return;
  try {
    

  // Initialize carousel when DOM is ready
  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => initCarousels());
  } else {
    setTimeout(() => initCarousels(), 1);
  }

  function initCarousels() {
    if (window.innerWidth <= 768) {
      document.querySelectorAll('.features-carousel').forEach(carouselElement => {
        const wrapper = carouselElement.querySelector('[data-carousel="true"]');
        if (wrapper && !wrapper.classList.contains('carousel-initialized')) {
          wrapper.classList.add('carousel-initialized');
          
          const track = wrapper.querySelector('.features-carousel__track');
          const dots = wrapper.querySelectorAll('.features-carousel__dot');
          
          if (!track) return;
          
          const carousel = {
            wrapper,
            track,
            dots,
            autoplayInterval: null,
            isAutoplayEnabled: wrapper.dataset.autoplay === 'true',
            autoplaySpeed: parseInt(wrapper.dataset.autoplaySpeed) || 5000,
            isUserInteracting: false
          };
          
          initCarousel(carousel);
        }
      });
    }
  }

  function initCarousel(carousel) {
    const { wrapper, track, dots } = carousel;
    
    // Update dots on scroll
    track.addEventListener('scroll', () => handleScroll(carousel));
    
    // Dot click handlers
    dots.forEach(dot => {
      dot.addEventListener('click', (e) => {
        stopAutoplay(carousel);
        handleDotClick(carousel, e);
      });
    });

    // Touch/swipe support
    let touchStartX = 0;
    let touchEndX = 0;

    track.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
      stopAutoplay(carousel);
    });

    track.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe(carousel, touchStartX, touchEndX);
    });

    // Pause autoplay on user interaction
    track.addEventListener('mousedown', () => {
      carousel.isUserInteracting = true;
      stopAutoplay(carousel);
    });

    track.addEventListener('mouseup', () => {
      carousel.isUserInteracting = false;
    });

    // Start autoplay if enabled
    if (carousel.isAutoplayEnabled) {
      startAutoplay(carousel);
    }
  }

  function startAutoplay(carousel) {
    if (carousel.autoplayInterval) return;
    
    carousel.autoplayInterval = setInterval(() => {
      if (!carousel.isUserInteracting) {
        const currentIndex = getCurrentIndex(carousel);
        const nextIndex = (currentIndex + 1) % carousel.dots.length;
        scrollToSlide(carousel, nextIndex);
      }
    }, carousel.autoplaySpeed);
  }

  function stopAutoplay(carousel) {
    if (carousel.autoplayInterval) {
      clearInterval(carousel.autoplayInterval);
      carousel.autoplayInterval = null;
    }
  }

  function handleScroll(carousel) {
    const scrollLeft = carousel.track.scrollLeft;
    const itemWidth = carousel.track.querySelector('.features-carousel__item').offsetWidth;
    const gap = 16; // 1rem gap
    const currentIndex = Math.round(scrollLeft / (itemWidth + gap));
    
    updateActiveDot(carousel, currentIndex);
  }

  function handleDotClick(carousel, e) {
    const index = parseInt(e.currentTarget.dataset.index);
    scrollToSlide(carousel, index);
  }

  function handleSwipe(carousel, startX, endX) {
    const swipeThreshold = 50;
    const diff = startX - endX;

    if (Math.abs(diff) < swipeThreshold) return;

    const currentIndex = getCurrentIndex(carousel);
    
    if (diff > 0) {
      // Swipe left - next slide
      scrollToSlide(carousel, currentIndex + 1);
    } else {
      // Swipe right - previous slide
      scrollToSlide(carousel, currentIndex - 1);
    }
  }

  function getCurrentIndex(carousel) {
    const scrollLeft = carousel.track.scrollLeft;
    const itemWidth = carousel.track.querySelector('.features-carousel__item').offsetWidth;
    const gap = 16;
    return Math.round(scrollLeft / (itemWidth + gap));
  }

  function scrollToSlide(carousel, index) {
    const items = carousel.track.querySelectorAll('.features-carousel__item');
    if (index < 0 || index >= items.length) return;

    const item = items[index];
    const scrollLeft = item.offsetLeft - (carousel.track.offsetWidth - item.offsetWidth) / 2;
    
    carousel.track.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });

    updateActiveDot(carousel, index);
  }

  function updateActiveDot(carousel, index) {
    carousel.dots.forEach((dot, i) => {
      if (i === index) {
        dot.classList.add('is-active');
        dot.setAttribute('aria-selected', 'true');
      } else {
        dot.classList.remove('is-active');
        dot.setAttribute('aria-selected', 'false');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jv-product-list-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('[data-testid="product-list-tabs"]');
    
    sections.forEach(section => {
      const tabs = section.querySelectorAll('[role="tab"]');
      const panels = section.querySelectorAll('[role="tabpanel"]');
      
      function switchTab(selectedTab) {
        const targetPanel = selectedTab.getAttribute('aria-controls');
        
        // Update tabs
        tabs.forEach(tab => {
          const isSelected = tab === selectedTab;
          tab.setAttribute('aria-selected', isSelected);
          tab.classList.toggle('active', isSelected);
        });
        
        // Update panels with animation
        panels.forEach(panel => {
          const isTarget = panel.id === targetPanel;
          
          if (isTarget) {
            panel.classList.add('active');
          } else {
            panel.classList.remove('active');
          }
        });
      }
      
      function handleKeyboard(e) {
        const tabsArray = Array.from(tabs);
        const currentIndex = tabsArray.indexOf(e.currentTarget);
        let newIndex;

        switch(e.key) {
          case 'ArrowLeft':
            e.preventDefault();
            newIndex = currentIndex - 1;
            if (newIndex < 0) newIndex = tabsArray.length - 1;
            tabsArray[newIndex].focus();
            switchTab(tabsArray[newIndex]);
            break;
          case 'ArrowRight':
            e.preventDefault();
            newIndex = currentIndex + 1;
            if (newIndex >= tabsArray.length) newIndex = 0;
            tabsArray[newIndex].focus();
            switchTab(tabsArray[newIndex]);
            break;
          case 'Home':
            e.preventDefault();
            tabsArray[0].focus();
            switchTab(tabsArray[0]);
            break;
          case 'End':
            e.preventDefault();
            tabsArray[tabsArray.length - 1].focus();
            switchTab(tabsArray[tabsArray.length - 1]);
            break;
        }
      }
      
      // Add event listeners
      tabs.forEach(tab => {
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          switchTab(e.currentTarget);
        });
        tab.addEventListener('keydown', handleKeyboard);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jv-video-stories"] && !Shopify.designMode) return;
  try {
    
  class VideoStories {
    constructor(element) {
      this.element = element;
      this.track = element.querySelector('.video-stories__track');
      this.stories = element.querySelectorAll('.video-story');
      this.prevBtn = element.querySelector('.video-stories__arrow--prev');
      this.nextBtn = element.querySelector('.video-stories__arrow--next');
      this.dots = element.querySelectorAll('.video-stories__dot');
      
      this.currentIndex = 0;
      this.autoPlay = element.dataset.autoPlay === 'true';
      this.autoPlaySpeed = parseInt(element.dataset.autoPlaySpeed) || 5000;
      this.autoPlayTimer = null;
      
      this.init();
    }

    init() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.prev());
      }
      
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.next());
      }
      
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });
      
      // Keyboard navigation
      this.element.addEventListener('keydown', (e) => this.handleKeyboard(e));
      
      // Touch/swipe support
      this.addSwipeSupport();
      
      // Pause auto-play on hover
      if (this.autoPlay) {
        this.startAutoPlay();
        
        this.element.addEventListener('mouseenter', () => this.stopAutoPlay());
        this.element.addEventListener('mouseleave', () => this.startAutoPlay());
        
        // Pause on focus
        this.element.addEventListener('focusin', () => this.stopAutoPlay());
        this.element.addEventListener('focusout', () => this.startAutoPlay());
      }
      
      // Pause videos when not in view
      this.setupIntersectionObserver();
    }

    goToSlide(index) {
      this.currentIndex = index;
      const visibleSlides = window.innerWidth > 749 
        ? parseInt(getComputedStyle(this.track).getPropertyValue('--visible-slides-desktop') || 5)
        : parseInt(getComputedStyle(this.track).getPropertyValue('--visible-slides-mobile') || 2);
      
      const maxIndex = Math.max(0, this.stories.length - visibleSlides);
      this.currentIndex = Math.min(this.currentIndex, maxIndex);
      
      const story = this.stories[this.currentIndex];
      const gap = parseInt(getComputedStyle(this.track).getPropertyValue('--story-gap') || 16);
      const offset = story.offsetLeft;
      
      this.track.style.transform = `translateX(-${offset}px)`;
      
      this.updateDots();
      this.pauseAllVideos();
    }

    prev() {
      if (this.currentIndex > 0) {
        this.goToSlide(this.currentIndex - 1);
      }
    }

    next() {
      const visibleSlides = window.innerWidth > 749 
        ? parseInt(getComputedStyle(this.track).getPropertyValue('--visible-slides-desktop') || 5)
        : parseInt(getComputedStyle(this.track).getPropertyValue('--visible-slides-mobile') || 2);
      
      if (this.currentIndex < this.stories.length - visibleSlides) {
        this.goToSlide(this.currentIndex + 1);
      } else if (this.autoPlay) {
        this.goToSlide(0); // Loop back to start
      }
    }

    updateDots() {
      this.dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === this.currentIndex);
      });
    }

    handleKeyboard(e) {
      switch(e.key) {
        case 'ArrowLeft':
          e.preventDefault();
          this.prev();
          break;
        case 'ArrowRight':
          e.preventDefault();
          this.next();
          break;
      }
    }

    addSwipeSupport() {
      let startX = 0;
      let currentX = 0;
      let isDragging = false;

      this.track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        isDragging = true;
      });

      this.track.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        currentX = e.touches[0].clientX;
      });

      this.track.addEventListener('touchend', () => {
        if (!isDragging) return;
        
        const diff = startX - currentX;
        
        if (Math.abs(diff) > 50) {
          if (diff > 0) {
            this.next();
          } else {
            this.prev();
          }
        }
        
        isDragging = false;
      });
    }

    startAutoPlay() {
      if (!this.autoPlay) return;
      
      this.stopAutoPlay();
      this.autoPlayTimer = setInterval(() => {
        this.next();
      }, this.autoPlaySpeed);
    }

    stopAutoPlay() {
      if (this.autoPlayTimer) {
        clearInterval(this.autoPlayTimer);
        this.autoPlayTimer = null;
      }
    }

    pauseAllVideos() {
      const videos = this.element.querySelectorAll('video');
      videos.forEach(video => {
        if (!video.paused) {
          video.pause();
        }
      });
    }

    setupIntersectionObserver() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) {
            this.pauseAllVideos();
            this.stopAutoPlay();
          } else if (this.autoPlay) {
            this.startAutoPlay();
          }
        });
      }, { threshold: 0.5 });

      observer.observe(this.element);
    }
  }

  // Initialize all video stories sections
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.video-stories').forEach(element => {
      new VideoStories(element);
    });
  });

  // Reinitialize on section reload (Shopify theme editor)
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const element = event.target.querySelector('.video-stories');
      if (element) {
        new VideoStories(element);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-specifications"] && !Shopify.designMode) return;
  try {
    
  // Tooltip functionality
  document.addEventListener('DOMContentLoaded', function() {
    const infoButtons = document.querySelectorAll('.specification-block__info-button');
    
    infoButtons.forEach(button => {
      const tooltipId = button.dataset.tooltipId;
      const tooltip = document.getElementById(tooltipId);
      
      if (!tooltip) return;
      
      // Toggle tooltip on click
      button.addEventListener('click', function(e) {
        e.stopPropagation();
        
        // Close all other tooltips
        document.querySelectorAll('.specification-tooltip:not([hidden])').forEach(t => {
          if (t !== tooltip) {
            t.setAttribute('hidden', '');
          }
        });
        
        // Toggle this tooltip
        if (tooltip.hasAttribute('hidden')) {
          tooltip.removeAttribute('hidden');
        } else {
          tooltip.setAttribute('hidden', '');
        }
      });
      
      // Hover to show (optional)
      button.addEventListener('mouseenter', function() {
        tooltip.removeAttribute('hidden');
      });
      
      button.addEventListener('mouseleave', function() {
        // Small delay before hiding
        setTimeout(() => {
          if (!tooltip.matches(':hover')) {
            tooltip.setAttribute('hidden', '');
          }
        }, 100);
      });
      
      // Keep tooltip open when hovering over it
      tooltip.addEventListener('mouseenter', function() {
        tooltip.removeAttribute('hidden');
      });
      
      tooltip.addEventListener('mouseleave', function() {
        tooltip.setAttribute('hidden', '');
      });
    });
    
    // Close tooltips when clicking outside
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.specification-block__info-wrapper')) {
        document.querySelectorAll('.specification-tooltip:not([hidden])').forEach(tooltip => {
          tooltip.setAttribute('hidden', '');
        });
      }
    });
    
    // Close on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.specification-tooltip:not([hidden])').forEach(tooltip => {
          tooltip.setAttribute('hidden', '');
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
